<template>
  <div class="" 
       @keydown.down="selectedIndex = selectedIndex < valuesShowing.length - 1 ? selectedIndex + 1 : selectedIndex;" 
       @keydown.up="selectedIndex = selectedIndex > - 1 ? selectedIndex - 1 : selectedIndex;"
       @keydown.enter="onEnterClicked"
       @focusin="visible=true" 
       @focusout="visible=false; selectedIndex = 0;">
  <div class="autocomplete-form-input-elements">
    <input id="autocomplete-form-input"
           autocomplete="off"
           class="w-100 form-control"
           name="tag"
           @input="onInputHandler" 
           v-model="text"  
           type="text">  
    
  </div>
  <div class="list-group list-group-flush autocomplete-form-items" v-if="text">
      <button v-for="(val,index) in valuesShowing" 
              :key="index" 
              :data-id="index"
              class="list-group-item list-group-item-action" 
              :class="{active:selectedIndex == index}" 
              @click="onClickHandler"
              @mouseover="selectedIndex = index">
        {{val}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
props: {
    values: Array,
    value: String
  },
  data(){
    return{
      text: "",
      valuesShowing: [],
      visible: false,
      selectedIndex: 0
    }
  },
  methods: {
    onInputHandler(e){
      const formData = new FormData();
      formData.append("search_param", e.target.value);
      formData.append("limit", 10);

      this.$store
        .dispatch("ArticleModule/postTags", formData)
        .then(response => {
          // console.log(this.$props.values.filter(a => a.includes(e.target.value)).splice(0,5));
          console.log('response');
          this.loading = false;
          var suggest = [];
          response.data.data.results.map(function(value, key) {
            suggest.push(value.tag);
          });
          this.$data.valuesShowing = suggest;
          this.$emit('input', this.$data.text);
        })
        .catch(error => {
          console.log(error);
        });
    },
    onClickHandler(e){
      this.$data.text = e.target.innerHTML.trim();
      this.selectedIndex = e.target.dataset["id"];
      this.$emit('input', this.$data.text);
      e.target.blur();
      this.$data.valuesShowing = [];
    },
    onEnterClicked(e){
      this.$data.text = this.$data.valuesShowing[this.$data.selectedIndex].trim();
      this.$emit('input', this.$data.text);
      e.target.blur();
      this.$data.valuesShowing = [];
    }
  }
}
</script>

<style>
#root {
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
#root .auto-input {
  width: 200px;
}

.autocomplete-form {
  margin-top: 25px;
  margin-left: 15px;
  margin-right: 15px;
}
.autocomplete-form-input-elements {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
.autocomplete-form-items {
  position: absolute;
  width: inherit;
  border-width: 1px;
  border-style: solid;
  border-color: lightgrey;
  z-index: 1;
}
.autocomplete-form input {
  margin-bottom: 1px;
}
.autocomplete-form .hide {
  display: none;
}
</style>